import { Link } from "wouter";
import { personas } from "@/lib/personas-data";
import { ArrowRight } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";
import { useLocale } from "@/hooks/useLocale";

export default function SolutionsHub() {
  const { localizedHref } = useLocale();
  usePageMeta({
    title: "Solutions by Role",
    description: "Curated professional tool bundles for how you actually work — marketing, legal, HR, real estate, freelancing, and more.",
    path: "/solutions",
  });

  return (
    <div className="container max-w-5xl mx-auto py-12 px-4">
      <h1 className="text-3xl font-bold mb-3 gradient-text">Tools for How You Work</h1>
      <p className="text-muted-foreground mb-10 max-w-2xl">
        Same professional tools, organized around your actual job — not a generic category list. Pick what you do, see the tools that fit.
      </p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {personas.map(persona => (
          <Link key={persona.id} href={localizedHref(`/solutions/${persona.id}`)}>
            <div className="p-5 rounded-xl border border-border bg-card hover:border-primary/30 transition-colors cursor-pointer h-full flex flex-col group">
              <div
                className="w-11 h-11 rounded-lg flex items-center justify-center mb-3"
                style={{ backgroundColor: `${persona.color}15` }}
              >
                <persona.icon className="h-5 w-5" style={{ color: persona.color }} />
              </div>
              <h2 className="font-semibold text-base mb-1.5 card-heading">{persona.title}</h2>
              <p className="text-sm text-muted-foreground leading-relaxed flex-1">{persona.tagline}</p>
              <div className="mt-3 flex items-center text-xs text-primary font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                View Toolkit <ArrowRight className="ml-1 h-3 w-3" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
